//START GENAI@GHCOPILOT
import { error } from 'common/errors';
import { asyncMarkWrapper } from 'common/instrumentation';
import { getState, resetApiResponseCache, resetUserProfile } from 'orch-communicator/store';
import { getSupportedCardNetworks } from 'orch-communicator/store/selectors';

//START GENAI
/**
 * Unbinds app instance for all supported networks or specific networks only
 * @param specificNetworks - Optional array of specific networks to unbind (e.g., ['MASTERCARD'])
 * @returns Promise with response array or error
 */
export default async function unbindAppInstance(specificNetworks?: string[]) {
  /* START GENAI@GHCOPILOT */
  //eslint-disable-next-line
  const vSDK = getState().srcSdks.loadedSdk as { [key: string]: any };
  const idTokens = getState().srcSdks.apiResponseCache.idTokens;
  const allCardBrands = getSupportedCardNetworks();

  // Use specific networks if provided, otherwise use all supported networks
  const cardBrands =
    specificNetworks && specificNetworks.length > 0
      ? specificNetworks.filter(network => allCardBrands.includes(network))
      : allCardBrands;

  const promises = [];

  try {
    if (idTokens.idTokens.length > 0) {
      for (const brand of cardBrands) {
        promises.push(
          asyncMarkWrapper('unbindAppInstance', brand, vSDK[brand].unbindAppInstance(idTokens))
        );
      }
    } else {
      for (const brand of cardBrands) {
        promises.push(
          asyncMarkWrapper('unbindAppInstance', brand, vSDK[brand].unbindAppInstance({}))
        );
      }
    }

    const response = await Promise.all(promises);

    // Only reset user profile and cache if unbinding all networks
    if (!specificNetworks || specificNetworks.length === 0) {
      resetUserProfile();
      resetApiResponseCache();
    }

    return response;
  } catch (e) {
    /* END GENAI@GHCOPILOT */
    return error('AUTH_INVALID', 'Failed to invoke unbind');
  }
}
//END GENAI
//END GENAI@GHCOPILOT
